module.exports = __webpack_public_path__ + "static/img/role.1186760.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/team/role.png
// module id = y36Q
// module chunks = 7